import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserProvider } from '../../services/user/user';
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class BibliaProvider {
  VERSAO: string = "afc24de218ef6e38-01";
  API_BIBLIA: string = "https://api.scripture.api.bible/v1/bibles/";
  API_KEY: string = "93ad60c6468f3d7bb682a5346d13dbd8";

  constructor(public http: HttpClient, public userProvider: UserProvider) {
    this.API_KEY = this.userProvider.hasBiblia();
  }

  getLivros() {
    const header = {
      'Content-Type': 'application/json',
      'api-key': this.API_KEY
    }
    return this.http.get<any>(this.API_BIBLIA + this.VERSAO + '/books', { headers: header }).pipe(map(data => {
      if (!data.error) {
        return data.data;
      } else {
        return false;
      }
    }));
  }

  getCapitulos(livro: string) {
    const header = {
      'Content-Type': 'application/json',
      'api-key': this.API_KEY
    }

    return this.http.get<any>(this.API_BIBLIA + this.VERSAO + '/books/' + livro + '/chapters', { headers: header }).pipe(map(data => {
      if (!data.error) {
        //REMOVER INTRO
        let capitulos: any = [];
        data.data.forEach((element: { number: string; }) => {
          if (element.number != 'intro') {
            capitulos.push(element);
          }
        });
        return capitulos;
      } else {
        return false;
      }
    }));
  }

  getCapitulo(capitulo: string) {
    const header = {
      'Content-Type': 'application/json',
      'api-key': this.API_KEY
    }

    return this.http.get<any>(this.API_BIBLIA + this.VERSAO + '/passages/' + capitulo, { headers: header }).pipe(map(data => {
      if (!data.error) {
        return data.data;
      } else {
        return false;
      }
    }));
  }

  getVersiculos(capitulo: string) {
    const header = {
      'Content-Type': 'application/json',
      'api-key': this.API_KEY
    }

    return this.http.get<any>(this.API_BIBLIA + this.VERSAO + '/chapters/' + capitulo + '/verses', { headers: header }).pipe(map(data => {
      if (!data.error) {
        return data.data;
      } else {
        return false;
      }
    }));
  }

  getVersiculo(versiculo: string) {
    const header = {
      'Content-Type': 'application/json',
      'api-key': this.API_KEY
    }

    return this.http.get<any>(this.API_BIBLIA + this.VERSAO + '/verses/' + versiculo, { headers: header }).pipe(map(data => {
      if (!data.error) {
        return data.data;
      } else {
        return false;
      }
    }));
  }
}
